import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import ConfirmForm from "../../components/forms/ConfirmForm";
import {cancelResumeSubscriptionScheduling} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class ResumeSubscriptionSchedulingFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: []
    }      
  }

  handleSubmit(values) {
    return this.props.resumeSubscriptionScheduling(values.set("subscriptionId", this.props.subscriptionId).toJS())
      .then((response) => {
        if (response.data.resumeSubscriptionScheduling.errors.length <= 0) {
          cancelResumeSubscriptionScheduling();
        } else {
          let errors = createValidationErrors(response.data.resumeSubscriptionScheduling.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelResumeSubscriptionScheduling();
  }

  render() {
    return (
      <ConfirmForm
        errors={this.state.errors}
        message="Are you sure you want to resume the scheduling for this subscription?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
 
}

const RESUME_SUBSCRIPTION_SCHEDULING = gql`
  mutation resumeSubscriptionScheduling($subscriptionId: ID!) {
    resumeSubscriptionScheduling(subscriptionId: $subscriptionId) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(RESUME_SUBSCRIPTION_SCHEDULING, {
    props: ({ mutate }) => ({
      resumeSubscriptionScheduling: (data) => mutate({
        variables: data
      })
    })
  })
);

export default connect(null, {cancelResumeSubscriptionScheduling})(withQueries(ResumeSubscriptionSchedulingFormContainer));